import { IMatchComment, IMatchComments } from '@sky-it-livedata/livedata-sports-design-system';

import { isNotEmptyArray, isNumeric } from './tests';


export const ID_WRAPPER_COMMENTS: string = 'match-comments-top';

export const optionsScrollTo: ScrollIntoViewOptions = {
  behavior: 'smooth',
  block: 'nearest',
  inline: 'center',
};

export const defaultMatchComments: IMatchComments = {
  comments: [],
  isLive: false,
  newPostsCount: 0,
  firstCommentDate: '',
  lastCommentDate: '',
  homeTeam: {
    seoName: '',
    customName: '',
  },
  awayTeam: {
    seoName: '',
    customName: '',
  },
  competition: {
    seoName: '',
    customName: '',
  },
  matchStatus: '',
  url: '',
  updatesBadge: {
    count: 0,
    isVisible: false,
  },
};

// Find INDEX of LATEST POST in UPDATED payload
export const getNewPostsIndex = (prev: Array<IMatchComment>, next: Array<IMatchComment>): number => {
  if (isNotEmptyArray(prev) && isNotEmptyArray(next)) {
    // Searching ID of 1st COMMENT before update
    const index: number = next.findIndex((comment: IMatchComment) => comment.commentId === prev![0].commentId) ?? 0;

    return index > 0 ? index : 0;
  }

  return 0;
};

// Get PAGE NUMBER from URL
export const getPageNumber = (fallback: number): number => {
  const searchParams = new URLSearchParams(location.search);
  const lbp: string = searchParams.has('lbp') ? searchParams.get('lbp') ?? String(fallback) : String(fallback);
  const pageNumber: number = isNumeric(lbp) ? Number(lbp) : fallback;

  return pageNumber;
};

// Get CURRENT URL without SEARCH PARAMS
export const getUrlWithoutSearchParams = (): string => {
  const url = new URL(location.href);
  url.search = '';

  return url.toString();
};
